<template>
    <div class="page-header page-header-light" v-show="currentRoute.path !== '/login'">
        <div class="page-header-content header-elements-md-inline">
            <div class="page-title d-flex">
                <h4>
                    <router-link :to="pageHeader.main.defaultPath?pageHeader.main.defaultPath:pageHeader.main.path" style="color:#333">
                        <i class="icon-home2 mr-2"></i>
                        <span class="font-weight-semibold">{{pageHeader.main.text}}</span>
                    </router-link>
                </h4>
                <h4 v-if="pageHeader.sub">
                    <router-link :to="pageHeader.sub.path" style="color:#333">
                        <i class="icon-circle-right2 mr-2 ml-2"></i>
                        <span class="font-weight-semibold">{{pageHeader.sub.text}}</span>
                    </router-link>
                </h4>
<!--                <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"></i></a>-->
            </div>

            <div class="header-elements d-none">
                <div class="d-flex justify-content-center">
<!--                    <a href="#" class="btn btn-link btn-float text-default"><i class="icon-bars-alt text-primary"></i><span>Statistics</span></a>-->
<!--                    <a href="#" class="btn btn-link btn-float text-default"><i class="icon-calculator text-primary"></i> <span>Invoices</span></a>-->
<!--                    <a href="#" class="btn btn-link btn-float text-default"><i class="icon-calendar5 text-primary"></i> <span>Schedule</span></a>-->
                </div>
            </div>
        </div>

        <div class="breadcrumb-line breadcrumb-line-light header-elements-md-inline">
            <div class="d-flex">
                <div class="breadcrumb">
                    <a href="javascript:void(0)" class="breadcrumb-item">
                        <i class="icon-info22 mr-2"/><a href="/assets/document/document.pptx" v-if="pageName ==='eventDetails'">how to create template.pptx</a>
                    </a>
                </div>
                <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"/></a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "layout-page-header",
        computed: {
            pageHeader:function() {
                let pageHeader = {}
                let list = this.$router.options.list
                list.forEach((item) => {
                    if (item.path === this.currentRoute.path) {
                        pageHeader = {
                            main: item,
                        }
                    } else {
                        if (item.child) {
                            item.child.forEach((sub) => {
                                if (sub.path === this.currentRoute.path){
                                    pageHeader = {
                                        main: item,
                                        sub: sub
                                    }
                                }
                            })
                        }
                    }
                })
                return pageHeader
            },
            pageName: function() {
                return this.$route.name
            }
        },
    }
</script>

<style scoped>
    a.router-link-active{
        color:#333
    }
</style>
